import { render, staticRenderFns } from "./OrdinaryRank.vue?vue&type=template&id=f1d424e0&scoped=true&"
import script from "./OrdinaryRank.vue?vue&type=script&lang=js&"
export * from "./OrdinaryRank.vue?vue&type=script&lang=js&"
import style0 from "./OrdinaryRank.vue?vue&type=style&index=0&id=f1d424e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d424e0",
  null
  
)

export default component.exports